const decimalOdds = num => {
  try {
    const parsedNum = parseFloat(num);

    if (parsedNum <= 1.005) {
      return '-';
    } else if (parsedNum < 10) {
      // round to 2 decimals for less than 10
      return parsedNum.toFixed(2);
    } else if (parsedNum < 100) {
      // round to 1 decimals for 10 to 100
      return parsedNum.toFixed(1);
    } else if (parsedNum >= 100) {
      // round to no decimals for > 100
      return parsedNum.toFixed(0);
    } else {
      return parsedNum;
    }
  } catch (error) {
    return '-';
  }
};

export default decimalOdds;
